import { Component, OnInit, ViewChild } from '@angular/core';
import { Zaposleni } from './zaposleni';
import { BaseDataService, BaseTabsUpdateComponent, TabsContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { ZaposleniUpdateComponent } from './zaposleni-update.component';

@Component({
  selector: 'yt-zaposleni-tab-update',
  templateUrl: './zaposleni-tab-update.component.html',
  styleUrls: ['./zaposleni-tab-update.component.scss']
})
export class ZaposleniTabUpdateComponent
  extends BaseTabsUpdateComponent<Zaposleni>
  implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<Zaposleni>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  @ViewChild("baseUpdate", { static: true }) baseUpdate: ZaposleniUpdateComponent;

  ngOnInit() {
    super.ngOnInit();
  }

  handleAddItemEvent(){}

}
